import { Link } from "lucide-react";
import React from "react";

const BlogHeroSection = () => {
  return (
    <div className="relative bg-gradient-to-r from-[#730000] to-[#b83d3d] text-white cursor-default">
      {/* Top curved decoration */}
      <div className="absolute top-0 left-0 right-0 h-6 bg-white rounded-b-[100%] transform translate-y-[-50%]"></div>

      <div className="container mx-auto px-4 py-20 flex flex-col items-center text-center max-w-5xl">
        <div className="mb-6 bg-white p-3 rounded-full shadow-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#730000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>

        {/* Blog Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-eb-garam font-bold mb-6">
          SelectProposal Blog
        </h1>

        {/* Blog Description */}
        <p className="text-lg md:text-xl lg:text-2xl font-seasons max-w-3xl mb-10">
          Insights, strategies and success stories to help you create winning
          business proposals
        </p>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 120"
          fill="#ffffff"
          preserveAspectRatio="none"
          className="w-full h-10 md:h-16"
        >
          <path d="M0,64L48,69.3C96,75,192,85,288,90.7C384,96,480,96,576,80C672,64,768,32,864,26.7C960,21,1056,43,1152,53.3C1248,64,1344,64,1392,64L1440,64L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
        </svg>
      </div>

      {/* Featured Categories Pills */}
      <div className="absolute bottom-[-20px] left-0 right-0 flex justify-center">
        <div className="flex flex-wrap gap-2 justify-center">
          <Link
            href="#"
            className="bg-white text-[#730000] px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition-colors font-medium text-sm"
          >
            Business Tips
          </Link>
          <Link
            href="#"
            className="bg-white text-[#730000] px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition-colors font-medium text-sm"
          >
            Success Stories
          </Link>
          <Link
            href="#"
            className="bg-white text-[#730000] px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition-colors font-medium text-sm"
          >
            Technology
          </Link>
          <Link
            href="#"
            className="bg-white text-[#730000] px-4 py-2 rounded-full shadow-md hover:bg-gray-100 transition-colors font-medium text-sm"
          >
            Sales Strategy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogHeroSection;
